import settings from '~/settings';

import type { ClanInfoType } from '~/Actions/ActionClanProfile';
import type { ClanPreloaded } from '~/types/declaration';

type ClanIsFullProps =
  | { members_count: number; max_members_count?: number }
  | { members_count: number; maxMembersCount?: number }
  | { membersCount: number; max_members_count?: number }
  | { membersCount: number; maxMembersCount?: number };

export const clanIsFull = (clan: ClanIsFullProps) => {
  const members = 'members_count' in clan ? clan.members_count : clan.membersCount;

  const maxMembers =
    'max_members_count' in clan ? clan.max_members_count : 'maxMembersCount' in clan ? clan.maxMembersCount : null;

  if (!maxMembers) {
    return false;
  }

  return members >= maxMembers;
};

export const clanCost = () => {
  return settings.clanCreate.cost - settings.clanCreate.discount;
};

export const isClanPreloaded = (clan: ClanInfoType | ClanPreloaded): clan is ClanPreloaded => {
  return clan && 'isPreloadedData' in clan && clan.isPreloadedData === true;
};
